var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2963_32669)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.5,
    height: 34.5,
    transform: "translate(0.75)",
    fill: "#F9CF66"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2963_32669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 9.21776C23.4817 9.95411 24.5 11.4831 24.5 13.25C24.5 15.0169 23.4817 16.5459 22 17.2822M24 22.5164C25.5115 23.2003 26.8725 24.315 28 25.75M8 25.75C9.94649 23.2726 12.5892 21.75 15.5 21.75C18.4108 21.75 21.0535 23.2726 23 25.75M20 13.25C20 15.7353 17.9853 17.75 15.5 17.75C13.0147 17.75 11 15.7353 11 13.25C11 10.7647 13.0147 8.75 15.5 8.75C17.9853 8.75 20 10.7647 20 13.25Z",
    stroke: "#FFFBE5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2963_32669"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 34.5,
    height: 34.5,
    rx: 17.25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2963_32669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(6.5 5.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.53ed7e448ac06c694af5699f541a621e.svg";
export { ForwardRef as ReactComponent };